import React from 'react';

export default function BadgeCell({ value }) {
  if (value) {
    return <img src={`/badges/${value}.webp`} height={28} alt={value} />;
  }
  return <span>-</span>;
}
